module.exports = "/assets/dd9da4a709e2743c124de8f859d6734e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CB.png
// module id = 1259
// module chunks = 0